const getNames = (arr = []) => {
    return arr.map(item => item.name);
};
const updateGameContext = (state = {}, action) => {
    const {
        type = null,
        datasource,
        data = {}
    } = action;

    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {
        const {
            gameData: {
                datetime: {
                    dateTime
                },
                status: {
                    abstractGameCode,
                    startTimeTBD,
                    extendedStatus,
                    abstractGameState
                },
                teams = {},
                probablePitchers
            } = {},
            liveData: {
                linescore: {
                    currentInningOrdinal,
                    inningState,
                    teams: {
                        home: {
                            runs: runsHome
                        },
                        away: {
                            runs: runsAway
                        }
                    }
                }
            }
        } = data;

        return {
            ...state,
            gameState: abstractGameCode,
            extendedStatus,
            abstractGameState,
            probablePitchers,
            gameDetailInfo: {
                inningState: {
                    currentInning: currentInningOrdinal,
                    inningHalf: inningState
                },
                teams: {
                    home: {
                        ...teams.home,
                        runs: runsHome
                    },
                    away: {
                        ...teams.away,
                        runs: runsAway
                    }
                },
                gameTime: dateTime,
                startTimeTBD
            }
        };
    }
    if (type === 'dataEngine_update_response' && datasource === 'schedule') {
        const {
            isFreeGame,
            story,
            mediaLinks
        } = data;
        const { audio, tv } = mediaLinks;
        const broadcasters = new Set(getNames(tv?.list));
        const homeTV = tv?.list?.filter(entry => entry.homeAway === 'home');
        const awayTV = tv?.list?.filter(entry => entry.homeAway === 'away');
        const nationalBroadcasts = tv?.list?.filter(entry => entry.isNational);
        return {
            ...state,
            storyUrl: story,
            broadcastInfo: {
                isFreeGame,
                audioFeed: audio?.teams?.home,
                broadcasters: [...broadcasters],
                tvFeeds: {
                    home: homeTV,
                    away: awayTV,
                    national: nationalBroadcasts
                }
            }
        };
    }

    return state;
};

export default updateGameContext;
